module.exports = __webpack_public_path__ + "img/salasofaazul.58d21caf.webp";